var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductOverviewImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 73L75 90C150 107 300 141 450 157C600 173 750 171 825 170L900 169L900 0L825 0C750 0 600 0 450 0C300 0 150 0 75 0L0 0Z",
    fill: "#992dff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 109L75 127C150 145 300 181 450 198C600 215 750 213 825 212L900 211L900 167L825 168C750 169 600 171 450 155C300 139 150 105 75 88L0 71Z",
    fill: "#a84eff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 211L75 224C150 237 300 263 450 268C600 273 750 257 825 249L900 241L900 209L825 210C750 211 600 213 450 196C300 179 150 143 75 125L0 107Z",
    fill: "#b669ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 277L75 293C150 309 300 341 450 345C600 349 750 325 825 313L900 301L900 239L825 247C750 255 600 271 450 266C300 261 150 235 75 222L0 209Z",
    fill: "#bb73ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 361L75 376C150 391 300 421 450 417C600 413 750 375 825 356L900 337L900 299L825 311C750 323 600 347 450 343C300 339 150 307 75 291L0 275Z",
    fill: "#b669ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 571L75 565C150 559 300 547 450 547C600 547 750 559 825 565L900 571L900 335L825 354C750 373 600 411 450 415C300 419 150 389 75 374L0 359Z",
    fill: "#a84eff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 601L75 601C150 601 300 601 450 601C600 601 750 601 825 601L900 601L900 569L825 563C750 557 600 545 450 545C300 545 150 557 75 563L0 569Z",
    fill: "#992dff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOverviewImage);
export default __webpack_public_path__ + "static/media/product_overview_image.087252cc782f2b67d70e1b742eff001c.svg";
export { ForwardRef as ReactComponent };